import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME } from './constants';

class NdObjednavkaProvider extends BaseApi {
	constructor() {
		super(MODULE_API, NAME);
	}

	async ndObjednavkaUzaverka(filter: Record<string, any>) {
		return this.post(`/${MODULE_API}/${NAME}/NdObjednavkaUzaverka`, filter);
	}
}

export const apiProvider = new NdObjednavkaProvider();
